module.exports = __webpack_public_path__ + "c9a1dd0362af1ec6c25fe7ffff6d0725.svg";